import { BrandPageQueryObj } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { useLoggedOutCategoryPageCatNavRequest } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/__internal__/useLoggedOutCategoryPageCatNavRequest";
import { wrapAsyncFn } from "@faire/web/common/wrapAsyncFn";
import fetchProductCatNav from "@faire/web-api--source/endpoints/www/api/v2/search/products/cat-nav/post";
import { getQueryKey as getQueryKeyProductCatNav } from "@faire/web-api--source/endpoints/www/api/v2/search/products/cat-nav/post-hooks";
import { IProductFirstCatNavWithLeanProductTileResponse } from "@faire/web-api--source/indigofair/data/IProductFirstCatNavWithLeanProductTileResponse";
import { useQuery } from "@tanstack/react-query";

const STALE_TIME = 1000 * 60 * 5;
export const useLoggedOutCategoryPageCatNavResponse = () => {
  const request = useLoggedOutCategoryPageCatNavRequest();
  const {
    data: response,
    isFetching,
    error,
    dataUpdatedAt,
  } = useQuery({
    queryKey: getQueryKeyProductCatNav(request),
    queryFn: ({ signal }) =>
      wrapAsyncFn(() => fetchProductCatNav(request, { signal }), {
        after: () => {
          PerformanceMarker.get().mark(PageLoadEvent.primaryFetchEnd);
        },
      }),
    staleTime: STALE_TIME,
  });
  const data = setProductFirstResponseInformation(response);

  return {
    data,
    error,
    isFetching,
    dataUpdatedAt,
    request,
  };
};

const setProductFirstResponseInformation = (
  response: IProductFirstCatNavWithLeanProductTileResponse | undefined
) => {
  const productFirstSearchResults = response?.product_tiles?.map(
    (productTile) => {
      const brand =
        response?.brand_by_token[productTile.product?.brand_token ?? ""];

      return {
        ...productTile,
        brand,
      };
    }
  );
  return {
    productFirstSearchResults,
    requestId: response?.request_id,
    paginationData: response?.pagination_data,
    pageCount: response?.pagination_data?.page_count || 0,
    totalPrimaryResultsCount:
      response?.formatted_total_primary_results_count ?? "",
    brandPageQueryParams: response?.brand_page_query_parameters as
      | BrandPageQueryObj
      | undefined,
    relatedSearchTerms: response?.related_search_terms ?? [],
    moreInC3CategoryName: response?.more_in_c3?.more_in_c3_category_name,
    moreInC3Terms: response?.more_in_c3?.more_in_c3_terms ?? [],
  };
};
